if (!customElements.get("m-collection-list")) {
  class MCollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper",
        slideInner: ".m-mixed-layout__inner",
      };
      this.classes = {
        grid: 'm:grid',
        hidden: 'm:hidden',
        swiper: 'swiper-container',
        swiperWrapper: 'swiper-wrapper'
      };
      this.domNodes = queryDomNodes(this.selectors, this);

      this.slider = false;

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.total = this.dataset.total;
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = this.dataset.autoplaySpeed;
      this.paginationType = this.dataset.paginationType;
      this.expanded = this.dataset.expanded === "true";
      this.mobileDisableSlider = this.dataset.mobileDisableSlider === "true";

      this.init();
      document.addEventListener("matchMobile", () => { this.init(); });
      document.addEventListener("unmatchMobile", () => { this.init(); });
    }

    init() {
      if (!this.enableSlider) {
        this.initStaticControls();
        return;
      }
      if (MinimogTheme.config.mqlMobile && this.mobileDisableSlider) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initStaticControls() {
      // Pehle se bind hone par dobara bind mat karo
      if (this._staticControlsBound) return;
      this._staticControlsBound = true;

      const slideControls = this.querySelector(".m-slider-controls");
      if (!slideControls) return;

      const prevButton = slideControls.querySelector(".m-slider-controls__button-prev");
      const nextButton = slideControls.querySelector(".m-slider-controls__button-next");
      if (!prevButton && !nextButton) return;

      // Controls dikhao
      slideControls.classList.remove('m:hidden');

      // Scroll container — mixed layout wrapper
      const scrollContainer = this.querySelector(".m-mixed-layout__wrapper");
      if (!scrollContainer) return;

      // Mobile pe horizontal scroll chahiye
      scrollContainer.style.overflowX = 'auto';
      scrollContainer.style.scrollSnapType = 'x mandatory';
      scrollContainer.style.webkitOverflowScrolling = 'touch';

      // Har card pe scroll snap lagao
      const cards = this.querySelectorAll('.m\\:column');
      cards.forEach(card => {
        card.style.scrollSnapAlign = 'start';
      });

      // Card width + gap = ek scroll step
      const getScrollStep = () => {
        const firstCard = this.querySelector('.m\\:column');
        if (!firstCard) return 200;
        const wrapperStyle = window.getComputedStyle(scrollContainer);
        const gap = parseInt(wrapperStyle.columnGap) || parseInt(wrapperStyle.gap) || 10;
        return firstCard.offsetWidth + gap;
      };

      if (nextButton) {
        nextButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          scrollContainer.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
        });
      }

      if (prevButton) {
        prevButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          scrollContainer.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
        });
      }

      // Arrow disabled state
      const updateButtons = () => {
        const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
        if (prevButton) prevButton.toggleAttribute('disabled', scrollContainer.scrollLeft <= 2);
        if (nextButton) nextButton.toggleAttribute('disabled', scrollContainer.scrollLeft >= maxScroll - 2);
      };

      scrollContainer.addEventListener('scroll', updateButtons, { passive: true });
      // Thodi der baad run karo taaki DOM settle ho jaye
      setTimeout(updateButtons, 300);
    }

    initSlider() {
      const { slideContainer, slideControls, slideInner } = queryDomNodes(this.selectors, this);

      const prevButton = slideControls && slideControls.querySelector(".m-slider-controls__button-prev");
      const nextButton = slideControls && slideControls.querySelector(".m-slider-controls__button-next");
      const paginationIcon = `<svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg>`;

      this.options = {
        slidesPerView: 2,
        loop: true,
        slidesPerGroup: 1,
        showNavigation: true,
        showPagination: true,
        parallax: true,
        autoplay: this.autoplay ? { delay: parseInt(this.autoplaySpeed) * 1000 } : false,
        pagination: this.paginationType == "fraction"
          ? { el: this.querySelector(".swiper-pagination"), clickable: true, type: "fraction" }
          : {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
              renderBullet: function (index, className) {
                return '<span class="' + className + '">' + paginationIcon + "</span>";
              },
            },
        navigation: nextButton || prevButton
          ? { nextEl: nextButton && nextButton, prevEl: prevButton && prevButton }
          : false,
        autoHeight: true,
        breakpoints: {
          480: { slidesPerView: 3 },
          768: { slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items) },
          1280: {
            slidesPerView: this.expanded && this.total > this.items
              ? parseInt(this.items) + 1
              : parseInt(this.items),
          },
        }
      };

      if (typeof this.slider !== 'object') {
        slideContainer.classList.add(this.classes.swiper);
        slideInner.classList.remove(this.classes.grid);
        slideInner.classList.add(this.classes.swiperWrapper);
        slideControls && slideControls.classList.remove(this.classes.hidden);
        this.slider = new MinimogLibs.Swiper(slideContainer, this.options);
      }
    }

    destroySlider() {
      const { slideContainer, slideControls, slideInner } = queryDomNodes(this.selectors, this);

      slideContainer.classList.remove(this.classes.swiper);
      slideInner.classList.remove(this.classes.swiperWrapper);
      slideInner.classList.add(this.classes.grid);
      slideControls && slideControls.classList.add(this.classes.hidden);

      if (typeof this.slider === 'object') {
        this.slider.destroy();
        this.slider = false;
      }
    }
  }

  customElements.define("m-collection-list", MCollectionList);
}
